import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "I'm a brand-new coach. Is this too advanced for me?",
  a: 'It is built for exactly that situation. Volume 01 walks you through tryouts and placement, Volume 02 gives you the first eight weeks of conditioning and technique, and Bonus 05 gives you a day-by-day plan for your first two weeks with the team.'
}, {
  q: 'What levels and team types does it cover?',
  a: 'Stunt progressions run from level 1 to level 6, with variants for all-star, high school, middle school and recreational teams. The practice picker tells you which version to use for the team in front of you.'
}, {
  q: 'Is this safe? Does it follow the rules?',
  a: 'Every progression includes spotting positions and readiness checks, and skills are sequenced so nothing is attempted before its prerequisites. It does not replace your certification or your governing body rulebook — NFHS and USASF update rules each season, and you verify what is legal for your setting before you run it.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Digital PDFs, laid out for printing. Most coaches print the practice sheets and trackers and keep them on a clipboard at the mat.'
}, {
  q: 'Is this just another blank planner?',
  a: 'No. Planners give you empty pages and calendars. This gives you the written practices, drills, scripts and progressions that were supposed to go on those pages.'
}, {
  q: 'Can I use it for a school program?',
  a: 'Yes. It is built for school, youth and all-star programs, and includes the documentation side: scorecards, athlete-parent agreements, incident reports and budget tracking.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-white text-ink" data-id="element-69" data-mp="1ugulht0pw5oz">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-70" data-mp="1uixnlbf59pa2">
        <div className="text-center" data-id="element-71" data-mp="1pp3345rpt69x">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-72" data-mp="1po1l1hca7jip">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-73" data-mp="1fsgmjt6f91dp">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-74" data-mp="28gcgiq4lwf6s">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-ice-dark bg-white" data-id="element-75" data-mp="23jm1850mlnmf" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-76" data-mp="s2m9pbm3rctg">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-77" data-mp="38n985rqwusfb" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-78" data-mp="3idu1azntf4qu" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-79" data-mp="3rd7arsbxvtbk">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}